import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--narrow _mt-6" }
const _hoisted_2 = {
  class: "gfu-heading gfu-heading--main",
  "data-qa": "page-title"
}
const _hoisted_3 = { class: "gfu-subheading gfu-subheading--main" }
const _hoisted_4 = { class: "_sr-only" }
const _hoisted_5 = ["data-qa"]
const _hoisted_6 = { class: "gfu-1of1 gfu-1of2--s gfu-1of3--m" }
const _hoisted_7 = {
  key: 3,
  class: "gfu-heading gfu-heading--top-divider _mt-4"
}
const _hoisted_8 = {
  key: 6,
  class: "gfu-hd gfu-hd--h3 _mt-5"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_cart_table = _resolveComponent("cart-table")
  const _component_base_button = _resolveComponent("base-button")
  const _component_order_details_location = _resolveComponent("order-details-location")
  const _component_shipping_model_selection_form = _resolveComponent("shipping-model-selection-form")
  const _component_order_summary_list = _resolveComponent("order-summary-list")
  const _component_dynamic_currency_conversion_wrapper = _resolveComponent("dynamic-currency-conversion-wrapper")
  const _component_payment_types = _resolveComponent("payment-types")
  const _component_adyen_order_payment_form = _resolveComponent("adyen-order-payment-form")
  const _component_stripe_payment_form = _resolveComponent("stripe-payment-form")
  const _component_checkout_footer = _resolveComponent("checkout-footer")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_box = _resolveComponent("box")
  const _component_project_context_modal = _resolveComponent("project-context-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.Resources.Checkout.CheckoutHeader), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.Resources.Checkout.CheckoutSubHeader), 1 /* TEXT */),
    _createVNode(_component_box, {
      class: "_mt-3 _mb-6",
      "data-qa": "cart-box"
    }, {
      default: _withCtx(() => [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.Resources.Checkout.CheckoutProductsSectionTitle), 1 /* TEXT */),
        _createVNode(_component_cart_table, { "order-id": _ctx.currentOrderId }, null, 8 /* PROPS */, ["order-id"]),
        ($options.isManageYourPledgeButtonVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              "data-qa": `begin-order-form-button:${$options.checkoutReturnActionDataQa}`
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_base_button, {
                  tag: "a",
                  href: $props.checkoutReturnActionUrl,
                  shape: "default",
                  display: "block"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.ManageYourPledgeButton), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["href"])
              ])
            ], 8 /* PROPS */, _hoisted_5))
          : _createCommentVNode("v-if", true),
        ($options.isOrderDetailsLocationVisible)
          ? (_openBlock(), _createBlock(_component_order_details_location, _mergeProps({ key: 1 }, $options.orderDetailsLocationProps, { onOrderDetailsLocationChanged: $options.onOrderDetailsLocationChanged }), null, 16 /* FULL_PROPS */, ["onOrderDetailsLocationChanged"]))
          : _createCommentVNode("v-if", true),
        ($options.isShippingSelectionFormVisible)
          ? (_openBlock(), _createBlock(_component_shipping_model_selection_form, {
              key: 2,
              "shipping-models": _ctx.shippingModels,
              "shipping-model-id": _ctx.shippingModel,
              "handle-tax": $props.handleTaxWithoutShipping,
              "is-amending-shipping": $props.isAmendingShipping
            }, null, 8 /* PROPS */, ["shipping-models", "shipping-model-id", "handle-tax", "is-amending-shipping"]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_order_summary_list, { "order-id": _ctx.currentOrderId }, null, 8 /* PROPS */, ["order-id"]),
        ($options.isOrderToPay)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_7, _toDisplayString(_ctx.Resources.Checkout.CheckoutPaymentOptionsSectionTitle), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        ($data.isInitialized)
          ? (_openBlock(), _createBlock(_component_dynamic_currency_conversion_wrapper, {
              key: 4,
              "project-id": $props.projectId,
              "order-id": _ctx.currentOrderId,
              reason: _ctx.paymentMethodsByOrderPaymentType,
              "can-be-paid-in-installments": _ctx.canBePaidInInstallments,
              "handle-tax-without-shipping": $props.handleTaxWithoutShipping,
              "payment-currency-strategy": $props.paymentCurrencyStrategy
            }, null, 8 /* PROPS */, ["project-id", "order-id", "reason", "can-be-paid-in-installments", "handle-tax-without-shipping", "payment-currency-strategy"]))
          : _createCommentVNode("v-if", true),
        ($options.isPaymentTypesVisible)
          ? (_openBlock(), _createBlock(_component_payment_types, {
              key: 5,
              "current-payment-type": $data.selectedPaymentType,
              "checkout-mode": $props.checkoutMode,
              "effective-payable-amount": $options.effectivePayableAmount,
              onPaymentTypeChanged: $options.onPaymentTypeChanged,
              "data-qa": "installments-wrapper"
            }, null, 8 /* PROPS */, ["current-payment-type", "checkout-mode", "effective-payable-amount", "onPaymentTypeChanged"]))
          : _createCommentVNode("v-if", true),
        ($options.isOrderToPay)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_8, _toDisplayString(_ctx.Resources.Checkout.CheckoutPaymentMethodSectionTitle), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        ($options.isAdyenPaymentFormVisible)
          ? (_openBlock(), _createBlock(_component_adyen_order_payment_form, _mergeProps({ key: 7 }, $options.paymentFormProps, { "data-qa": "payment-section" }), null, 16 /* FULL_PROPS */))
          : _createCommentVNode("v-if", true),
        ($options.isStripePaymentFormVisible)
          ? (_openBlock(), _createBlock(_component_stripe_payment_form, _mergeProps({ key: 8 }, $options.paymentFormProps, { "data-qa": "stripe-payment-form" }), null, 16 /* FULL_PROPS */))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_checkout_footer),
        _createVNode(_component_progress_overlay, { visible: $setup.isProcessingView }, null, 8 /* PROPS */, ["visible"])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_project_context_modal)
  ]))
}